module.exports = __webpack_public_path__ + "img/3rpms-preview.a34186cd.jpg";